export const getView = width => {
    let view = 'MobileView'
    if (width > 1220) {
        view = 'DesktopView'
    } else if (width > 767) {
        view = 'TabView'
    }
    return view
}
